<template >
    <b-card no-body v-if="!field.isHidden" class="d-flex p-2" :class="field.ispercent? 'percentBG':''" :cols=columns style="height: 130px; padding-top: 1rem !important;">
        <div> <h3 class="kema-green text-center"> {{field.title}}</h3></div>
        <div v-if="loading" class="text-center"> 
          <b-spinner style="height: 28px; margin-top: 13px;" > </b-spinner>
        </div>
        <div v-else class="text-center p-3" >
            <strong v-if="field.isCurrency" v-html="formatTableCurrency"></strong>
            <strong v-else class="numbers text-center">{{formatThousands}}<span v-if="field.ispercent" style=" font-size: 12px; margin-right:5px; font-weight: 500; ">%</span></strong>
        </div>
        <div  v-if="!loading" class="text-center" ><strong v-html="prorateddata">
            </strong></div>
    </b-card>
</template>
<script>
export default {
  name: "customard",
  props: {
    isMobileDevice: {
      type: Boolean,
      default() {
          return false;
        },
    },
    field: {
        type: Object,
        default() {
          return [];
        },
      },
    loading: {
        type: Boolean,
        default() {
        return false;
        },
    },
    columns:{
        type:String,
        default(){
            return ''
        }
    },
    formatTableCurrency:{
        type: String,
        default(){
            return ``
        }
    },
    formatThousands:{
        type: String,
        default(){
            return ``
        }
    },
    prorateddata:{
        type: String,
        default(){
            return ``
        }
    },
    index:{
      type:Number,
      default(){
        return 0
      }
    }
    },
  methods: {
    
  },
};
</script>
<style lang="scss">
.kema-green {
  margin-right: auto;
  color: #737674;
  font-size: 14px;
}
.percentBG{
  background-color: #eeeef8;
}
@media (max-width: 991.98px) {
    .kema-green {
      font-size: 12px;
    }
}
.numeric {
  /* color: #73f3a9; */
  color: #000000;
  font-size: 28px;
  margin-left: -1rem;
}
.numbers {
  /* color: #73f3a9; */
  color: #000000;
  font-size: 28px;
}

.flex-break {
  height: 0;
  margin: 0;
  border: 0;
  width: 100%;
}

</style>